import React, { ChangeEvent, FC, useEffect, useState } from 'react'

import Select from 'react-select'

import CustomDatePicker from '../../../../../components/common/inputs/CustomDatePicker'
import { PatternFormat } from 'react-number-format'

import { getReactPickerDate } from '../../../../../models/interface.helper'
import { generatePhoneMask } from '../../../../../components/common/inputs/PhoneInput'

import { IOption } from '../../../../../components/inputs/InputNewMemberRow'

import { zoneList } from '../../../../../fakeData/ZoneList'
import { amateurList } from '../../../../../fakeData/amateurList'
import { disciplineData } from '../../../../../fakeData/disciplineList'
import { horseBreedList } from '../../../../../fakeData/horseBreedList'
import { horseHeightList } from '../../../../../fakeData/HorseHeightList'
import { horseColorList } from '../../../../../fakeData/horseColorList'
import { CountryList } from '../../../../../fakeData/countryList'
import {
  customStyles,
  geldingStatusOptions,
  SexRestOptions,
} from '../../../../../components/customStyles/ReactSelectCustomStyle'
import { horseMarkingList } from '../../../../../fakeData/horseMarkingList'

interface RequiredFieldInputProps {
  fieldKey: string
  fieldType: string
  value: IOption
  onChange: (option: IOption) => void
}
export const RequiredFieldInput: FC<RequiredFieldInputProps> = ({
  value,
  onChange,
  fieldKey,
  fieldType,
}) => {
  const [options, setOptions] = useState<IOption[]>([])

  useEffect(() => {
    switch (fieldKey) {
      case 'userZone':
        setOptions(zoneList)
        break
      case 'userAmateur':
        setOptions(amateurList)
        break
      case 'userDiscipline':
      case 'horseDiscipline':
        setOptions(disciplineData)
        break
      case 'horseBreed':
        setOptions(horseBreedList)
        break
      case 'horseHeight':
        setOptions(horseHeightList)
        break
      case 'horseGender':
        setOptions(SexRestOptions as IOption[])
        break
      case 'horseZone':
        setOptions(zoneList)
        break
      case 'horseColor':
        setOptions(horseColorList)
        break
      case 'horseCountry':
      case 'userNationality':
        setOptions(CountryList)
        break
      case 'horseGeldingStatus':
        setOptions(geldingStatusOptions)
        break
      case 'horseMarking':
        setOptions(horseMarkingList)
        break
      default:
        break
    }
  }, [fieldKey])

  const onChangeInputHandler = (e: ChangeEvent<HTMLInputElement>) => {
    if (fieldKey.toLowerCase().includes('number') && !fieldKey.includes('userPhoneNumber')) {
      if (/^\d*$/.test(e.target.value)) {
        onChange({ label: e.target.value, value: e.target.value })
      }
    } else if (fieldKey.includes('userPhoneNumber')) {
      if (/^[0-9-]+$/.test(e.target.value)) {
        onChange({ label: e.target.value, value: e.target.value.replace(/[- ]/g, '') })
      }
    } else {
      onChange({ label: e.target.value, value: e.target.value })
    }
  }

  return (
    <>
      {fieldType === 'date' ? (
        <CustomDatePicker
          name={fieldKey}
          value={value.value}
          onChange={(value) => onChange({ label: value, value: value })}
          selected={getReactPickerDate(value.value)}
          peekNextMonth
          disabled={false}
          dropdownMode="select"
          showMonthDropdown
          showYearDropdown
          maxDate={new Date()}
          placeholderText="Select date"
          className="bg-white rounded-xl w-full justify-end border focus:ring-[#D3DAEE] focus:border-[#D3DAEE] placeholder:text-[#122B4680] placeholder:text-sm opacity-1 py-2 text-sm border-[#D3DAEE]"
        />
      ) : fieldType === 'select' ? (
        <Select
          name={fieldKey}
          classNamePrefix="text-field"
          isMulti={false}
          value={value}
          onChange={(item) => onChange(item as IOption)}
          isDisabled={false}
          options={options}
          className="w-full bg-white border-[#D3DAEE] border py-[1px] !text-sm rounded-xl text-SeabiscuitDark200ThemeColor placeholder:text-SeabiscuitDark200ThemeColor"
          isClearable={false}
          styles={customStyles}
          isSearchable={true}
        />
      ) : fieldType === 'tel' ? (
        <PatternFormat
          name={fieldKey}
          format={generatePhoneMask(10)}
          mask={'_'}
          className="py-1.5 w-full bg-white rounded-xl border border-[#D3DAEE] text-SeabiscuitDark200ThemeColor"
          type="text"
          value={value.value}
          onChange={onChangeInputHandler}
        />
      ) : (
        <input
          name={fieldKey}
          className="py-1.5 w-full bg-white rounded-xl border border-[#D3DAEE] text-SeabiscuitDark200ThemeColor"
          type="text"
          value={value.value}
          onChange={onChangeInputHandler}
        />
      )}
    </>
  )
}
